import type { EventName } from "@lit/react";
import { IntegerField as IntegerFieldElement, type IntegerFieldEventMap as _IntegerFieldEventMap, } from "@vaadin/integer-field/vaadin-integer-field.js";
import * as React from "react";
import { createComponent, type WebComponentProps } from "../utils/createComponent.js";
export { IntegerFieldElement, };
export type IntegerFieldEventMap = Readonly<{
    onValidated: EventName<_IntegerFieldEventMap["validated"]>;
    onChange: EventName<_IntegerFieldEventMap["change"]>;
    onInput: EventName<_IntegerFieldEventMap["input"]>;
    onInvalidChanged: EventName<_IntegerFieldEventMap["invalid-changed"]>;
    onValueChanged: EventName<_IntegerFieldEventMap["value-changed"]>;
}>;
const events = { onValidated: "validated", onChange: "change", onInput: "input", onInvalidChanged: "invalid-changed", onValueChanged: "value-changed" } as IntegerFieldEventMap;
export type IntegerFieldProps = WebComponentProps<IntegerFieldElement, IntegerFieldEventMap>;
export const IntegerField = createComponent({
    elementClass: IntegerFieldElement, events, react: React, tagName: "vaadin-integer-field"
});
